exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Register_input_3BhHv{margin:10px 0}.Register_input_3BhHv,.Register_submit_UcW7A{display:block;padding:10px;width:100%}.Register_submit_UcW7A{border:0;outline:0;background-color:#2778ad;color:#fff;cursor:pointer;-webkit-transition:.2s;transition:.2s}.Register_submit_UcW7A:disabled{background-color:#999}.Register_submit_UcW7A:not(:disabled):hover{background-color:#186091}.Register_register_2I2N2{margin-bottom:20px}.Register_caption_3LPWQ{text-align:center;display:block;margin-top:10px;font-size:10px;cursor:pointer}.Register_errors_3ofU2{color:#d64545;font-size:11px;margin-top:10px;height:20px}.Register_exampleText_2umZx{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;font-size:small;color:#6f767c}", ""]);

// exports
exports.locals = {
	"input": "Register_input_3BhHv",
	"submit": "Register_submit_UcW7A",
	"register": "Register_register_2I2N2",
	"caption": "Register_caption_3LPWQ",
	"errors": "Register_errors_3ofU2",
	"exampleText": "Register_exampleText_2umZx"
};